import { alpha } from '@mui/material/styles';

// remember to import this file in index.js

export default function Backdrop(theme) {
  return {
    MuiBackdrop: {
      styleOverrides: {
        root: {
          backgroundColor: alpha(theme.palette.grey[800], 0.4),
        },
        invisible: {
          background: 'transparent',
        },
      },
    },
  };
}
